import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  name: Yup.string().min(3).required('Name is required'),
  isPrivate: Yup.boolean().required(),
})

export default validationSchema
